import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faLink } from "@fortawesome/free-solid-svg-icons";
import project_bloodBank from "../img/project_BloodBank.png";
import project_Whatsapp from "../img/project_Whatsapp.png";
import project_CrescentAi from "../img/project_CrescentAi.png";
import project_ComplaintManage from "../img/project_ComplaintManage.png";
import project_Ecomerce from "../img/project_Ecommerce.png";
import project_PersonalPortflio from '../img/project_personalPortfolio.png'

const PortfolioSection = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);

    const openModal = (project) => {
        setSelectedProject(project);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setSelectedProject(null);
    };

    const projects = [
        {
            title: "Blood Bank",
            description:
                "Save lives with [Blood Bank Name]. Find donation centers, check eligibility, and schedule your blood donation today!.",
            image: project_bloodBank,
            link: "https://finalhackathon2.netlify.app/",
        },
        {
            title: "E-Commerce",
            description:
                "Shop anytime, anywhere with our eCommerce platform. Discover a wide range of products, easy checkout, and secure payments.",
            image: project_Ecomerce,
            link: "https://ecommerce-clothing-sigma.vercel.app/",
        },
        {
            title: "Crescent AI",
            description:
                "An AI virtual assistant that helps with tasks, answers questions, schedules appointments, sends reminders, and more—making your life easier and more organized!",
            image: project_CrescentAi,
            link: "https://crescent-ai.netlify.app/",
        },
        {
            title: "Complaint Management System",
            description:
                "Streamline issue resolution with our Complaint Management System. Log, track, and resolve complaints efficiently for better customer satisfaction.",
            image: project_ComplaintManage,
            link: "https://complait-manage-system.netlify.app/",
        },
        {
            title: "WhatsApp",
            description:
                "Chatting, and share securely with our WhatsApp clone—fast, simple, and encrypted. Stay connected anytime!",
            image: project_Whatsapp,
            link: "https://whatshapp-clone.netlify.app/",
        },
    ];

    return (
        <section
            id="projects"
            className="bg-gray-900 cursor-default text-white py-16 px-6 md:px-12 lg:px-20"
        >
            <div className="max-w-6xl mx-auto">
                <h2 className="text-4xl font-bold text-center mb-12">
                    Portfolio <span className="text-teal-400">| Work Showcase</span>
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {projects.map((project, index) => (
                        <div
                            key={index}
                            className="bg-gray-800 rounded-lg overflow-hidden shadow-lg hover:scale-105 transition transform duration-300 cursor-pointer"
                            onClick={() => openModal(project)}
                        >
                            <img
                                src={project.image}
                                alt={project.title}
                                className="w-full h-48 object-cover"
                            />
                            <div className="p-6">
                                <h3 className="text-2xl font-semibold mb-4">{project.title}</h3>
                                <p className="text-gray-400 mb-4">{project.description}</p>
                                <a
                                    href={project.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-teal-400 hover:underline"
                                >
                                    View Project
                                </a>
                            </div>
                        </div>
                    ))}

                    <div className="relative flex justify-center items-center bg-gray-800 rounded-lg overflow-hidden shadow-lg hover:scale-105 transition transform duration-300 cursor-pointer group">
                        <div
                            style={{ backgroundImage: `url(${project_PersonalPortflio})` }}
                            className="absolute object-cover inset-0 bg-cover bg-center opacity-0 group-hover:opacity-100 group-hover:backdrop-blur-sm transition-opacity duration-300"
                            aria-hidden="true"
                        ></div>

                        <div className="relative w-full p-7 z-10">
                            <div className="flex justify-center mb-4">
                                <FontAwesomeIcon icon={faLink} className="text-gray-400 text-4xl" />
                            </div>
                            <div className="flex justify-center">
                                <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded transition duration-300">
                                    View Projects
                                </button>
                            </div>
                        </div>
                    </div>



                </div>
            </div>

            {isOpen && selectedProject && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                    onClick={closeModal}
                >
                    <div
                        className="bg-gray-800 rounded-lg shadow-lg p-9 w-11/12 max-w-lg text-center relative"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <button
                            className="absolute top-4 right-4 text-white hover:text-red-500 transition"
                            onClick={closeModal}
                        >
                            <FontAwesomeIcon icon={faTimes} size="lg" />
                        </button>

                        <img
                            src={selectedProject.image}
                            alt={selectedProject.title}
                            className="w-full h-64 object-cover rounded-lg mb-4"
                        />
                        <h3 className="text-2xl font-bold mb-4">{selectedProject.title}</h3>
                        <p className="text-gray-400 mb-6">{selectedProject.description}</p>
                        <a
                            href={selectedProject.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="px-4 py-2 bg-teal-500 rounded hover:bg-teal-600 transition text-white"
                        >
                            Visit Project
                        </a>
                    </div>
                </div>
            )}
        </section>
    );
};

export default PortfolioSection;
